<template>
  <el-dialog
    :title="$t('text.register_an_installation_id')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    append-to-body
    :modal-append-to-body="false"
    @close="closeDialog()"
    width="400px"
  >
    <div>
      <el-form
        label-width="110px"
        :model="form"
        ref="form"
        label-position="top"
      >
        <el-form-item
          :label="$t('text.installation_id')"
          prop="InstallationId"
          :rules="[
            {
              required: true,
              message: this.$t('text.please_enter_installation_id'),
              trigger: 'blur'
            }
          ]"
        >
          <el-input
            v-model="form.InstallationId"
            autocomplete="off"
            :placeholder="$t('text.installation_id')"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="linkFacility()"
        :loading="loading"
        >{{ $t('text.register').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        InstallationId: ''
      }
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.form = {
        InstallationId: ''
      }
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    linkFacility() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          ApiService.LinkFacility(
            this.$store.getters[`user/selecteOrganisationId`],
            this.form.InstallationId
          )
            .then(response => {
              this.loading = false
              if (response.data.success) {
                swal({
                  icon: 'success',
                  timer: 2000,
                  title: this.$t('text.register_an_installation_id_successful')
                })
                this.$emit('success')
                this.closeDialog()
              } else {
                swal({
                  icon: 'warning',
                  timer: 2000,
                  title: this.$t('text.failed'),
                  text: response.data.msg + '.'
                })
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>
